import {createAction, props} from "@ngrx/store";
import {AdhocProcessExpensesRequest} from "../../models/api.model";

const prefix = '[adhoc]'

export const ADHOC_LOAD_BANKING_INFO = createAction(`${prefix} adhoc_load_banking_info`)

export const ADHOC_PROCESS_EXPENSES = createAction(
  `${prefix} adhoc_process_expenses`,
  props<{ request: AdhocProcessExpensesRequest; file: File }>()
)
